import React from "react";
import { Button } from "antd";
import styles from "./NoResult.module.scss";
export function NoResult(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.noResult
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.noResultIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, "No results found"), /*#__PURE__*/React.createElement("div", {
    className: styles.des
  }, "Sorry, we couldn't find what you're looking for."), /*#__PURE__*/React.createElement(Button, {
    loading: props.loading,
    onClick: props.loadMore,
    className: styles.search,
    type: "primary"
  }, "Search again"));
}